import { useTranslation } from "react-i18next";
import { Box, Skeleton, Typography } from "@mui/material";

import { testimonialStyles } from "./styles";

const TestimonialsLoader = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "testimonials" });

  return (
    <Box sx={testimonialStyles.container}>
      <Typography sx={testimonialStyles.title}>{t("testimonials")}</Typography>
      <Box sx={testimonialStyles.card.container}>
        <Box sx={testimonialStyles.card.content}>
          <Box sx={testimonialStyles.card.header.container}>
            <Box sx={testimonialStyles.card.header.avatarContainer}>
              <Skeleton variant="circular" width={40} height={40} />
              <Box sx={testimonialStyles.card.header.userInfo}>
                <Skeleton width={120} height={24} />
                <Skeleton width={80} height={18} />
              </Box>
            </Box>
          </Box>
          <Box sx={testimonialStyles.card.body.container} mt={2}>
            <Skeleton width="100%" height={24} />
            <Skeleton width="75%" height={24} />

            <Box sx={testimonialStyles.card.body.skillsContainer}>
              {[1, 2, 3].map((index) => (
                <Box key={index} sx={testimonialStyles.card.skillMeter.container}>
                  <Box sx={testimonialStyles.card.skillMeter.header}>
                    <Skeleton width={100} height={18} />
                    <Skeleton width={30} height={16} />
                  </Box>
                  <Skeleton variant="rectangular" width="100%" height={16} sx={{ borderRadius: "4px" }} />
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TestimonialsLoader;
